/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-14 09:57:36
 * @LastEditors: linxi
 * @LastEditTime: 2024-04-12 14:35:43
 */
import { TableColumnType } from 'antd'
import moment from 'moment'
import React from 'react'
import { DateTimeFormat, DateTimeFormatSimple } from '../../models/datetime'
import { Dimen } from '../../models/dimen'
import styles from './recentTime.module.css'
import { selectSettings } from '../user/setting/settingSlice'
import { Checks } from '../../models/setting'
import { useSelector } from 'react-redux'

// 近效期管理列表
export const Columns = (
  startIndex: number,
  sortedInfo?: any
): TableColumnType<any>[] => {

  const settings = useSelector(selectSettings)
  
  // 新老目录展示方式 (老目录没有区分药品类别/无型号)
  const getProcuctInfo = (item: any) => {
    const materialsCategory = item.materialsCategory
    const packSpec = item.packSpec ? item.packSpec : '-'
    const spec = item.spec ? item.spec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const model = item.model ? ('/' + item.model) : ''
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'

    if (settings?.[Checks.MLKG] == 1) {
      if (materialsCategory == '0') {
        // 生产厂家 + 包装规格  +  剂型 
        return tenantSupplierName + '/' + packSpec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 包装规格  +  型号
        return tenantSupplierName + '/' + packSpec + model
      } else {
        // 生产厂家 + 包装规格 
        return tenantSupplierName + '/' + packSpec
      }
    } else {
      if (materialsCategory == '0') {
        // 生产厂家 + 规格  +  剂型 
        return tenantSupplierName + '/' + spec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 规格  +  型号
        return tenantSupplierName + '/' + spec + model
      } else {
        // 生产厂家 + 规格 
        return tenantSupplierName + '/' + spec
      }
    }
  }

  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '物资信息',
      align: 'left',
      dataIndex: '',
      render: function Element(_, record) {
        const deadline = moment(record.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        return (
          <div style={{ height: '55px' }}>
            <p
              className={styles.nameText}
            >
              {record.name}
            </p>
            <p
              className={styles.productText}
            >
              {getProcuctInfo(record)}
            </p>
          </div>
        )
      },
    },
    {
      title: '柜号',
      align: 'center',
      width: Dimen.BatchNo,
      dataIndex: 'cabineNo',
      render: function Element(_, t) {
        return (
          <div
            style={{
              color: '#333333'
            }}
          >
            {t.cabineNo}
          </div>
        )
      },
    },
    {
      title: '批次号',
      align: 'center',
      width: Dimen.BatchNo,
      dataIndex: 'batchNo',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        return (
          <div
            style={{
              color: '#333333'
            }}
          >
            {t.batchNo}
          </div>
        )
      },
    },
    {
      title: '有效期至',
      align: 'center',
      width: Dimen.Time,
      dataIndex: 'deadline',
      sorter: true,
      key: 'deadline',
      sortOrder: sortedInfo?.columnKey === 'deadline' && sortedInfo?.order,
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        return (
          <div
            onClick={() => {
              return
            }}
            style={{
              color:
                days > 180
                  ? '#000000'
                  : days > 90
                  ? '#027AFF'
                  : days > 30
                  ? '#FA8714'
                  : days > 0
                  ? '#FF5D5D'
                  : '#9564ad',
            }}
          >
            {moment(t.deadline).format(DateTimeFormatSimple)}
          </div>
        )
      },
    },
    {
      title: '库存数量',
      align: 'center',
      width: Dimen.Count,
      dataIndex: 'count',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        return (
          <div
            style={{
              color: '#333333'
            }}
          >
            {t.count} {t.accountUnit}
          </div>
        )
      },
    },
    {
      title: '拆零数量',
      align: 'center',
      width: Dimen.Count,
      dataIndex: 'splitCount',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days = duration.asDays()
        return (
          <div
            style={{
              color: '#333333'
            }}
          >
            {t.splitCount} {t.splitUnit}
          </div>
        )
      },
    },
    {
      title: '剩余天数',
      align: 'center',
      width: Dimen.Count,
      dataIndex: 'usedays',
      render: function Element(_, t) {
        const deadline = moment(t.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const days: any = duration.asDays()
        return (
          <div
            style={{
              color: '#333333'
            }}
          >
            {parseInt(days)}
          </div>
        )
      },
    },
  ]
}
